import styles from './NoGroupSelector.module.scss'
import { Checkbox } from '../../Atoms/Checkbox/Checkbox'

export const NoGroupSelector = ({
  translate,
  selectedCheckboxIds,
  setSelectedCheckboxIds,
  systems,
  checkboxColor
}) => {
  const isChecked = systemId => selectedCheckboxIds.includes(systemId)

  const handleSelectAll = () => {
    if (selectedCheckboxIds.includes('SELECT_ALL')) {
      setSelectedCheckboxIds([])
    } else {
      const allSystemIds = systems.map(system => system._id)
      setSelectedCheckboxIds(['SELECT_ALL', ...allSystemIds])
    }
  }

  const handleSystemChange = systemId => {
    if (isChecked(systemId)) {
      const newSelection = selectedCheckboxIds.filter(id => id !== systemId && id !== 'SELECT_ALL')
      setSelectedCheckboxIds(newSelection)
    } else {
      const newSelection = [...selectedCheckboxIds.filter(id => id !== 'SELECT_ALL'), systemId]
      const allSelected = systems.every(system => newSelection.includes(system._id))
      if (allSelected) {
        setSelectedCheckboxIds(['SELECT_ALL', ...systems.map(system => system._id)])
      } else {
        setSelectedCheckboxIds(newSelection)
      }
    }
  }

  return (
    <div className={styles.deviceListContent}>
      {systems.length > 0 && (
        <div className={styles.selectAllContainer}>
          <Checkbox
            value='SELECT_ALL'
            label={translate('selectAll')}
            onChange={handleSelectAll}
            isChecked={selectedCheckboxIds.includes('SELECT_ALL')}
            color={checkboxColor}
          />
        </div>
      )}
      <div className={styles.flatSystemList}>
        {systems.map(system => (
          <div
            key={system._id}
            className={styles.micaItem}
          >
            <Checkbox
              value={system._id}
              label={system.name}
              onChange={() => handleSystemChange(system._id)}
              isChecked={isChecked(system._id)}
              color={checkboxColor}
            />
          </div>
        ))}
      </div>
    </div>
  )
}
